export default __webpack_public_path__ + "static/media/illustration-work-3-w@3x.b3985305.webp";